"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOebbautocompleteDefaultStyle = exports.createOebbAutocompleteFromRemoteStringArrayWithTopResults = exports.createOebbAutocompleteFromRemoteStringArray = exports.createOebbAutocompleteFromStringArray = exports.OebbAutocomplete = void 0;
var OebbAutocomplete = /** @class */ (function () {
    function OebbAutocomplete(input, list) {
        this.useFirstItemOnEnter = false;
        this.showPanelOnFocus = false;
        this.isPanelAlwaysOpen = false;
        this.scrollSpaceTop = 0;
        this.isListOpen = false;
        this.hasFocus = false;
        this.activeElementIndex = -1;
        this.randId = Math.random().toString(36).substr(2, 6);
        this.data = [];
        this.input = input;
        this.list = list;
        this.initDom();
        this.initListeners();
        if (this.isPanelAlwaysOpen) {
            this.render();
        }
    }
    OebbAutocomplete.prototype.initDom = function () {
        this.input.setAttribute('autocomplete', 'off');
        this.template = defaultTemplate;
        this.activeCallback = defaultActive;
        this.selectCallback = defaultSelect;
        this.element = document.createElement('div');
        this.element.classList.add('oebb-autocomplete-wrapper');
        this.element.style.position = 'relative';
        this.input.parentNode.insertBefore(this.element, this.input);
        this.element.appendChild(this.input);
        if (!this.list) {
            this.list = document.createElement('ul');
            this.element.appendChild(this.list);
        }
        this.list.classList.add('oebb-autocomplete-list');
        this.list.classList.add('js-oebb-autocomplete-list');
        this.list.style.display = 'none';
        this.addAriaAttributesOnInput();
        this.addAriaAttributesOnList();
    };
    OebbAutocomplete.prototype.addAriaAttributesOnInput = function () {
        if (!this.input.id || this.input.id.trim() == '')
            console.warn('No attribute "id" on autocomplete input found.');
        this.input.setAttribute('role', 'combobox');
        this.input.setAttribute('aria-autocomplete', 'list');
        this.input.setAttribute('aria-controls', 'oebb-autocomplete-list-' + this.randId);
        this.input.setAttribute('aria-expanded', 'false');
        this.input.setAttribute('aria-activedescendant', '');
    };
    OebbAutocomplete.prototype.addAriaAttributesOnList = function (inputLabel) {
        var label = inputLabel !== null && inputLabel !== void 0 ? inputLabel : document.querySelector("[for=\"".concat(this.input.id, "\"]"));
        if (!label)
            return;
        label.setAttribute('id', 'oebb-autocomplete-label-' + this.randId);
        this.list.setAttribute('id', 'oebb-autocomplete-list-' + this.randId);
        this.list.setAttribute('role', 'listbox');
        this.list.setAttribute('aria-labelledby', 'oebb-autocomplete-label-' + this.randId);
    };
    OebbAutocomplete.prototype.refreshAriaAttributesOnItems = function () {
        if (this.items.length == 0)
            return;
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].setAttribute('id', 'oebb-autocomplete-item-' + this.randId + '-' + i);
            this.items[i].setAttribute('role', 'option');
            this.items[i].setAttribute('aria-selected', 'false');
        }
    };
    OebbAutocomplete.prototype.refreshAriaAttributesOnInput = function () {
        if (this.isListOpen) {
            this.input.setAttribute('aria-expanded', 'true');
        }
        else {
            this.input.setAttribute('aria-expanded', 'false');
        }
        if (this.activeElementIndex > -1) {
            this.input.setAttribute('aria-activedescendant', 'oebb-autocomplete-item-' + this.randId + '-' + this.activeElementIndex);
        }
        else {
            this.input.setAttribute('aria-activedescendant', '');
        }
    };
    OebbAutocomplete.prototype.toggleAriaAttributeSelected = function (i) {
        if (i < 0)
            return;
        this.input.setAttribute('aria-activedescendant', 'oebb-autocomplete-item-' + this.randId + '-' + i);
        var selected = this.items[i].getAttribute('aria-selected');
        if (selected === null || selected === 'false') {
            this.items[i].setAttribute('aria-selected', 'true');
        }
        else {
            this.items[i].setAttribute('aria-selected', 'false');
        }
    };
    OebbAutocomplete.prototype.initListeners = function () {
        var _this = this;
        this.input.addEventListener('focus', function () { return _this.handleFocus(); }, false);
        this.input.addEventListener('blur', function () { return _this.handleBlur(); }, false);
        this.input.addEventListener('keydown', function (e) { return _this.handleKeydown(e); }, false);
        this.input.addEventListener('keyup', function (e) { return _this.handleKeyup(e); }, false);
        this.list.addEventListener('mousedown', function (e) { return e.preventDefault(); }, false); // Prevent list from closing on item click because of "blur" event
        this.list.addEventListener('click', function (e) { return _this.handleItemClick(e); }, false);
    };
    OebbAutocomplete.prototype.withTemplate = function (template) {
        this.template = template;
        return this;
    };
    OebbAutocomplete.prototype.withFirstItemOnEnter = function () {
        this.useFirstItemOnEnter = true;
        return this;
    };
    OebbAutocomplete.prototype.withPanelOnFocus = function () {
        this.showPanelOnFocus = true;
        return this;
    };
    OebbAutocomplete.prototype.withPanelAlwaysOpen = function (activate) {
        if (activate === void 0) { activate = true; }
        if (activate) {
            this.isPanelAlwaysOpen = true;
        }
        else {
            this.isPanelAlwaysOpen = false;
        }
        return this;
    };
    OebbAutocomplete.prototype.withScrollSpaceTop = function (scrollSpaceTop) {
        this.scrollSpaceTop = scrollSpaceTop;
        return this;
    };
    OebbAutocomplete.prototype.onKeyup = function (keyupCallback) {
        this.keyupCallback = keyupCallback;
        return this;
    };
    OebbAutocomplete.prototype.onKeydown = function (keydownCallback) {
        this.keydownCallback = keydownCallback;
        return this;
    };
    OebbAutocomplete.prototype.onItemActive = function (activeCallback) {
        this.activeCallback = activeCallback;
        return this;
    };
    OebbAutocomplete.prototype.onItemSelect = function (selectCallback) {
        this.selectCallback = selectCallback;
        return this;
    };
    OebbAutocomplete.prototype.setData = function (data) {
        this.data = data;
    };
    OebbAutocomplete.prototype.getData = function () {
        return this.data;
    };
    OebbAutocomplete.prototype.setValue = function (value) {
        this.value = value;
        this.input.value = value;
    };
    OebbAutocomplete.prototype.addValue = function (value) {
        var valueParts = this.input.value.split(/\s+/);
        valueParts.pop();
        valueParts.push(value);
        this.value = valueParts.join(' ');
        this.input.value = this.value;
    };
    OebbAutocomplete.prototype.getValue = function () {
        return this.input.value;
    };
    OebbAutocomplete.prototype.getOriginalValue = function () {
        return this.originalValue;
    };
    OebbAutocomplete.prototype.getItems = function () {
        return this.items;
    };
    OebbAutocomplete.prototype.getActiveElementIndex = function () {
        return this.activeElementIndex;
    };
    OebbAutocomplete.prototype.handleFocus = function () {
        this.hasFocus = true;
        this.lastKeyCode = null;
        if (this.showPanelOnFocus)
            this.render();
    };
    OebbAutocomplete.prototype.handleBlur = function () {
        this.hasFocus = false;
        this.lastKeyCode = null;
        this.hideList();
    };
    OebbAutocomplete.prototype.handleKeydown = function (e) {
        this.toggleAriaAttributeSelected(this.activeElementIndex);
        if (this.activeElementIndex == -1)
            this.originalValue = this.getValue();
        switch (e.keyCode) {
            case 9:
                this.list.tabIndex = -1;
                return;
            case 13: // Enter
                if (this.isListOpen)
                    e.preventDefault(); // Prevent form submit
                if (this.activeElementIndex > -1)
                    this.selectCallback(this.activeElementIndex, e);
                if (this.useFirstItemOnEnter && this.isListOpen && this.data.length > 0 && this.activeElementIndex == -1)
                    this.selectCallback(0, e);
                this.hideList();
                break;
            case 27: // ESC
                if (this.activeElementIndex > -1)
                    e.stopPropagation();
                this.hideList();
                this.setValue(this.originalValue);
                break;
            case 38: // Up
                if (this.activeElementIndex > -1)
                    e.preventDefault();
                // Any element
                if (this.activeElementIndex > -1) {
                    this.items[this.activeElementIndex].classList.remove('oebb-autocomplete-item--active');
                    this.activeElementIndex--;
                }
                // Any element, still not first element
                if (this.activeElementIndex > -1)
                    this.items[this.activeElementIndex].classList.add('oebb-autocomplete-item--active');
                // Scroll to top after first element, usefull if groups are used
                if (this.activeElementIndex == -1)
                    this.list.scrollTop = 0;
                // If on element, fire activeCallback
                if (this.activeElementIndex == -1)
                    this.setValue(this.originalValue);
                if (this.activeElementIndex > -1)
                    this.activeCallback(this.activeElementIndex);
                break;
            case 40: // Down
                // List not open, no data
                if (this.data.length == 0)
                    return;
                // List not open
                if (!this.isListOpen && this.data.length > 0) {
                    this.activeElementIndex = -1;
                    this.render();
                    break;
                }
                // Last element
                if (this.activeElementIndex + 1 == this.items.length)
                    break;
                // Any element
                if (this.activeElementIndex > -1)
                    this.items[this.activeElementIndex].classList.remove('oebb-autocomplete-item--active');
                this.activeElementIndex++;
                this.items[this.activeElementIndex].classList.add('oebb-autocomplete-item--active');
                // If on element, fire activeCallback
                if (this.activeElementIndex == -1)
                    this.setValue(this.originalValue);
                if (this.activeElementIndex > -1)
                    this.activeCallback(this.activeElementIndex);
                break;
        }
        this.toggleAriaAttributeSelected(this.activeElementIndex);
        this.refreshAriaAttributesOnInput();
        if (this.keydownCallback)
            this.keydownCallback(e);
        // No element
        if (this.activeElementIndex == -1)
            return;
        if (e.keyCode == 38 && this.isListOpen && !this.isItemInListView()) {
            var y = this.items[this.activeElementIndex].offsetTop;
            this.list.scrollTop = y - this.scrollSpaceTop;
        }
        if (e.keyCode == 40 && this.isListOpen && !this.isItemInListView()) {
            var y = this.items[this.activeElementIndex].offsetTop - this.list.clientHeight + this.items[this.activeElementIndex].clientHeight;
            this.list.scrollTop = y;
        }
    };
    OebbAutocomplete.prototype.handleKeyup = function (e) {
        this.value = this.input.value;
        this.lastKeyCode = e.keyCode;
        if (e.keyCode === 13 || e.keyCode === 27 || e.keyCode === 38 || e.keyCode === 40)
            return;
        this.keyupCallback(e);
        this.render();
    };
    OebbAutocomplete.prototype.handleItemClick = function (e) {
        e.stopPropagation();
        var target = e.target;
        var item = target.closest('li');
        var items = Array.prototype.slice.call(this.list.querySelectorAll('.js-oebb-autocomplete-item'));
        var index = items.indexOf(item);
        this.selectCallback(index, e);
        this.hideList();
        this.input.focus();
    };
    OebbAutocomplete.prototype.isItemInListView = function () {
        var rectList = this.list.getBoundingClientRect();
        var rectItem = this.items[this.activeElementIndex].getBoundingClientRect();
        return rectItem.top >= rectList.top + this.scrollSpaceTop && rectItem.top <= rectList.top + rectList.height - rectItem.height; // top && bottom
    };
    OebbAutocomplete.prototype.hideList = function () {
        if (this.activeElementIndex > -1) {
            this.items[this.activeElementIndex].classList.remove('oebb-autocomplete-item--active');
            this.activeElementIndex = -1;
        }
        if (this.isPanelAlwaysOpen)
            return;
        if (!this.isListOpen)
            return;
        this.list.removeAttribute('tabindex');
        this.list.scrollTop = 0;
        this.list.style.display = 'none';
        this.isListOpen = false;
        this.refreshAriaAttributesOnInput();
    };
    OebbAutocomplete.prototype.render = function () {
        var _this = this;
        this.activeElementIndex = -1;
        this.list.removeAttribute('tabindex');
        this.list.scrollTop = 0;
        if (!this.isPanelAlwaysOpen) {
            if (!this.hasFocus)
                return this.hideList();
            if (this.data.length == 0)
                return this.hideList();
            if (!this.showPanelOnFocus && (!this.value || this.value == ''))
                return this.hideList();
            if (this.lastKeyCode === 13)
                return; // Prevents panel after submitting form because of suggestions via async request
        }
        var listHtml = "";
        this.list.innerHTML = "";
        this.data.forEach(function (item, i) {
            listHtml += _this.template(item, i);
        });
        this.list.innerHTML = listHtml;
        this.list.style.display = 'block';
        this.isListOpen = true;
        this.items = this.list.querySelectorAll('.js-oebb-autocomplete-item');
        // this.refreshItemListener();
        this.refreshAriaAttributesOnInput();
        this.refreshAriaAttributesOnItems();
    };
    return OebbAutocomplete;
}());
exports.OebbAutocomplete = OebbAutocomplete;
var FilterMode;
(function (FilterMode) {
    FilterMode["StartsWith"] = "STARTS_WITH";
    FilterMode["Contains"] = "CONTAINS";
})(FilterMode || (FilterMode = {}));
var defaultTemplate = function (item) {
    var valueParts = this.input.value.split(/\s+/);
    var valueLast = valueParts.pop().toString();
    if (item.toLowerCase().indexOf(valueLast.toLowerCase()) === 0) {
        return "<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">".concat(item.substring(0, valueLast.length) + "<strong>" + item.substring(valueLast.length), "</strong></li>");
    }
    return "<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">".concat(item, "</strong></li>");
};
var defaultActive = function () {
    this.addValue(this.items[this.activeElementIndex].textContent.trim());
};
var defaultSelect = function (index) {
    this.addValue(this.getData()[index]);
};
function createOebbAutocompleteFromStringArray(input, rawData, filterMode) {
    if (filterMode === void 0) { filterMode = FilterMode.StartsWith; }
    return new OebbAutocomplete(input)
        .withTemplate(defaultTemplate)
        .onKeyup(function () {
        var value = this.getValue().split(/\s+/).pop();
        if (!value.trim())
            return;
        var data = [];
        if (filterMode === FilterMode.Contains) {
            data = rawData.filter(function (option) {
                return option.toLowerCase().indexOf(value.toLowerCase()) > -1;
            });
        }
        else {
            data = rawData.filter(function (option) {
                return option.toLowerCase().indexOf(value.toLowerCase()) === 0;
            });
        }
        this.setData(data);
    })
        .onItemActive(defaultActive)
        .onItemSelect(defaultSelect);
}
exports.createOebbAutocompleteFromStringArray = createOebbAutocompleteFromStringArray;
function createOebbAutocompleteFromRemoteStringArray(input, url, options) {
    if (options === void 0) { options = {}; }
    options.paramKey = options.paramKey || 'q';
    options.suggestionsKey = options.suggestionsKey || 'suggestions';
    options.debounceTiming = options.debounceTiming;
    if (options.debounceTiming !== 0)
        options.debounceTiming = 500;
    var origin = url;
    var debounceTimer;
    return new OebbAutocomplete(input)
        .withTemplate(defaultTemplate)
        .onKeyup(function () {
        var _this = this;
        var value = this.getValue().split(/\s+/).pop();
        if (!value.trim())
            return;
        (function () {
            if (debounceTimer)
                clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                var url;
                if (origin.indexOf('?') > -1) {
                    url = origin + "&".concat(options.paramKey, "=").concat(value);
                }
                else {
                    url = origin + "?".concat(options.paramKey, "=").concat(value);
                }
                fetch(encodeURI(url))
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                    _this.setData(data[options.suggestionsKey]);
                    _this.render();
                })
                    .catch(function (e) { return console.error(e); });
            }, options.debounceTiming);
        })();
    })
        .onItemActive(defaultActive)
        .onItemSelect(defaultSelect);
}
exports.createOebbAutocompleteFromRemoteStringArray = createOebbAutocompleteFromRemoteStringArray;
function createOebbAutocompleteFromRemoteStringArrayWithTopResults(input, url, options) {
    if (options === void 0) { options = {}; }
    options.paramKey = options.paramKey || 'q';
    options.suggestionsKey = options.suggestionsKey || 'suggestions';
    options.suggestionsLabel = options.suggestionsLabel || 'Vorschläge';
    options.topResultsKey = options.topResultsKey || 'top_results';
    options.topResultsLabel = options.topResultsLabel || 'Beste Ergebnisse';
    options.typeMapping =
        options.typeMapping ||
            function (item) {
                return item.url.indexOf('.pdf') > -1 ? 'PDF' : 'Seite';
            };
    options.debounceTiming = options.debounceTiming;
    if (options.debounceTiming !== 0)
        options.debounceTiming = 500;
    var origin = url;
    var debounceTimer;
    return new OebbAutocomplete(input)
        .withTemplate(function (group, indexGroup) {
        var _this = this;
        var groupHtml = "";
        if (typeof group[0] === 'string') {
            groupHtml = "\n                    <li class=\"oebb-autocomplete-group\">\n                        <span class=\"oebb-autocomplete-group-label\">".concat(options.suggestionsLabel, "</span>\n                        <ul data-group=\"").concat(indexGroup, "\">\n                    ");
            group.forEach(function (item, indexItem) {
                var valueParts = _this.input.value.split(/\s+/);
                var valueLast = valueParts.pop().toString();
                groupHtml += "\n                        <li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\" data-item=\"".concat(indexItem, "\">\n                            <span class=\"oebb-autocomplete-item__title\">\n                                ").concat(item.substring(0, valueLast.length) + "<strong>" + item.substring(valueLast.length), "</strong>\n                            </span>\n                        </li>\n                    ");
            });
            groupHtml += "\n                        </ul>\n                    </li>\n                ";
        }
        if (typeof group[0] === 'object') {
            groupHtml = "\n                    <li class=\"oebb-autocomplete-group\">\n                        <span class=\"oebb-autocomplete-group-label\">".concat(options.topResultsLabel, "</span>\n                        <ul data-group=\"").concat(indexGroup, "\">\n                ");
            group.forEach(function (item, indexItem) {
                groupHtml += "\n                        <li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\" data-item=\"".concat(indexItem, "\">\n                            <span class=\"oebb-autocomplete-item__title\">").concat(item.title, "</span>\n                            <span class=\"oebb-autocomplete-item__type\">\n                                ").concat(options.typeMapping(item), "\n                            </span>\n                        </li>");
            });
            groupHtml += "\n                        </ul>\n                    </li>\n                ";
        }
        return groupHtml;
    })
        .onKeyup(function () {
        var _this = this;
        var value = this.getValue().split(/\s+/).pop();
        if (!value.trim())
            return;
        (function () {
            if (debounceTimer)
                clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                var url;
                if (origin.indexOf('?') > -1) {
                    url = origin + "&".concat(options.paramKey, "=").concat(value);
                }
                else {
                    url = origin + "?".concat(options.paramKey, "=").concat(value);
                }
                fetch(encodeURI(url))
                    .then(function (response) { return response.json(); })
                    .then(function (resultData) {
                    var data = [];
                    if (resultData[options.topResultsKey])
                        data.push(resultData[options.topResultsKey]);
                    if (resultData[options.suggestionsKey])
                        data.push(resultData[options.suggestionsKey]);
                    _this.setData(data);
                    _this.render();
                })
                    .catch(function (e) { return console.error(e); });
            }, options.debounceTiming);
        })();
    })
        .onItemActive(function (itemIndex) {
        var itemElement = this.getItems()[itemIndex];
        var group = itemElement.parentNode.dataset.group;
        var index = itemElement.dataset.item;
        var item = this.getData()[group][index];
        if (typeof item === 'string')
            this.addValue(item);
        if (typeof item === 'object')
            this.setValue(this.getOriginalValue());
    })
        .onItemSelect(function (itemIndex) {
        var itemElement = this.getItems()[itemIndex];
        var group = itemElement.parentNode.dataset.group;
        var index = itemElement.dataset.item;
        var item = this.getData()[group][index];
        if (typeof item === 'string')
            this.addValue(item);
        if (typeof item === 'object')
            window.location.href = item.url;
    });
}
exports.createOebbAutocompleteFromRemoteStringArrayWithTopResults = createOebbAutocompleteFromRemoteStringArrayWithTopResults;
function addOebbautocompleteDefaultStyle(tint) {
    if (tint === void 0) { tint = '#e2002a'; }
    if (document.querySelector('#js-oebb-autocomplete-styles'))
        return;
    var style = document.createElement('style');
    style.id = 'js-oebb-autocomplete-styles';
    style.innerHTML = "\n        .oebb-autocomplete-wrapper {\n            position: relative;\n        }\n\n        .oebb-autocomplete {}\n\n        .oebb-autocomplete-list {\n            position: absolute;\n            z-index: 10;\n\n            width: 100%;\n            max-height: 240px;\n            margin: 0;\n            padding: 0;\n            overflow-x: hidden;\n            overflow-y: auto;\n\n            background: #ffffff;\n            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19);\n            list-style: none;\n\n            font-size: 18px;\n        }\n\n        .oebb-autocomplete-list ul {\n            margin: 0;\n            padding: 0;\n\n            list-style: none;\n        }\n\n        .oebb-autocomplete-group-label,\n        .oebb-autocomplete-item {\n            display: inline-block;\n\n            width: 100%;\n            height: 40px;\n            padding: 6px 15px;\n            box-sizing: border-box;\n\n            line-height: 28px;\n        }\n\n        .oebb-autocomplete-group .oebb-autocomplete-item {\n            display: flex;\n            align-items: flex-start;\n\n            height: auto;\n            min-height: 40px;\n            margin-right: 10px\n        }\n\n        .oebb-autocomplete-group-label {\n            background: #efefef;\n\n            text-transform: uppercase;\n            font-weight: bold;\n        }\n\n        .oebb-autocomplete-item {\n            border-bottom: 1px solid #efefef;\n            cursor: pointer;\n        }\n\n        .oebb-autocomplete-item:hover,\n        .oebb-autocomplete-item--active {\n            color: ".concat(tint, ";\n        }\n\n        .oebb-autocomplete-item__type {\n            float: right;\n\n            display: block;\n            padding: 5px 12px;\n            margin-top: 1px;\n            margin-left: auto;\n\n            border: 1px solid currentColor;\n\n            font-size: 12px;\n            line-height: 1em;\n            letter-spacing: 1px;\n            text-transform: uppercase;\n        }\n    ");
    document.head.appendChild(style);
}
exports.addOebbautocompleteDefaultStyle = addOebbautocompleteDefaultStyle;
